import "core-js/stable";
import "regenerator-runtime/runtime";

import { getConfig } from "@edx/frontend-platform";
import { getAuthenticatedUser } from "@edx/frontend-platform/auth";
import React from "react";
import { Routes, Route } from "react-router-dom";
import { injectIntl } from "@edx/frontend-platform/i18n";

import "./index.scss";
import OutlineTab from "./course-home/outline-tab";
import { CourseExit } from "./courseware/course/course-exit";
import CoursewareContainer from "./courseware";
import CoursewareRedirectLandingPage from "./courseware/CoursewareRedirectLandingPage";
import CoordinatorTrackingTab from "./course-home/coordinatorTrackingTab";
import BookmarkTab from "./course-home/bookmarkTab";
import GoalUnsubscribe from "./course-home/goal-unsubscribe";
import { TabContainer } from "./tab-page";
import { ToastContainer } from 'react-toastify';

import {
  fetchOutlineTab,
  fetchCoordinatorTrackingTab,
} from "./course-home/data";
import { fetchCourse } from "./courseware/data";
import { useMobileResponsive } from './utils';

function App({ intl }) {
  const user = getAuthenticatedUser();
  const isMobile = useMobileResponsive();  

  if (!user) {
    const loginUrl = new URL(`${getConfig().LMS_BASE_URL}/login`);
    loginUrl.searchParams.append("next", window.location.href);
    window.location.replace(loginUrl.href);
  }

  return (
    <>
      <Routes>
        <Route
          path="/goal-unsubscribe/:token"
          element={<GoalUnsubscribe />}
        />
        <Route path="/redirect/*" element={<CoursewareRedirectLandingPage />} />
        <Route path="/course/:courseId/home/:type"
          element={
            <TabContainer tab="outline" fetch={fetchOutlineTab} slice="courseHome">
              <BookmarkTab />
            </TabContainer>
          }
        />
        <Route path="/course/:courseId/home"
          element={
            <TabContainer tab="outline" fetch={fetchOutlineTab} slice="courseHome">
              <OutlineTab activeTabSlug="courseware" />
            </TabContainer>
          }
        />
        {/* <Route path="/course/:courseId/dates">
    return (
      <Routes>
        <PageRoute
          exact
          path="/goal-unsubscribe/:token"
          component={GoalUnsubscribe}
        />
        <PageRoute path="/redirect" component={CoursewareRedirectLandingPage} />
        <PageRoute path="/course/:courseId/home/:type">
          <TabContainer tab="outline" fetch={fetchOutlineTab} slice="courseHome">
            <BookmarkTab />
          </TabContainer>
        </PageRoute>
        <PageRoute path="/course/:courseId/home">
          <TabContainer tab="outline" fetch={fetchOutlineTab} slice="courseHome">
            <OutlineTab activeTabSlug="courseware" />
          </TabContainer>
        </PageRoute>
        {/* <PageRoute path="/course/:courseId/dates">
            <TabContainer tab="dates" fetch={fetchDatesTab} slice="courseHome">
              <DatesTab />
            </TabContainer>
          </PageRoute> */}
        <Route path="/course/:courseId/coordinator-tracking"
          element={
            <TabContainer
              tab="coordinator_tracking"
              fetch={fetchCoordinatorTrackingTab}
              slice="courseHome"
            >
              <CoordinatorTrackingTab />
            </TabContainer>
          }
        />
        {/* <PageRoute
            path={[
              "/course/:courseId/progress/:targetUserId/",
              "/course/:courseId/progress",
            ]}
            render={({ match }) => (
              <TabContainer
                tab="progress"
                fetch={(courseId) =>
                  fetchProgressTab(courseId, match.params.targetUserId)
                }
                slice="courseHome"
              >
                <ProgressTab />
              </TabContainer>
            )}
          /> */}
        <Route path="/course/:courseId/course-end"
          element={
            <TabContainer tab="courseware" fetch={fetchCourse} slice="courseware">
              <CourseExit />
            </TabContainer>
          }
        />
        <Route
          path="/course/:courseId/:sectionId/:sequenceId/:unitId"
          element={<CoursewareContainer />}
        />
        <Route
          path="/course/:courseId/:sectionId/:sequenceId"
          element={<CoursewareContainer />}
        />
        <Route
          path="/course/:courseId/:sectionId"
          element={<CoursewareContainer />}
        />
      </Routes>

      <ToastContainer
        theme="colored"
        position={isMobile ? 'bottom-center' : 'bottom-left'}
      />
    </>
  );
}

export default injectIntl(App);
